import React from 'react';
import '../css/Footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-content">
                <div className="footer-logo">
                    <img src={process.env.PUBLIC_URL + '/goldencross-logo.svg'} width="100"></img>
                </div>
                <div className="about">
                    <p>Contact Us</p>
                    <p>GoldenCross</p>
                    <p>경기도 안양시 시민대로 398 더리브디하우트 지원동 706호</p>
                    <p></p>
                    {/* <p>Tel : </p>
                    <p>Email : </p> */}
                </div>
            </div>
            <div className="footer-bottom">&copy; 2024 | GoldenCross All rights reserved.</div>
        </div>
    );
};

export default Footer;
